import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAndWebView, isIOSWebView } from 'src/utils/constants';
import { getUA, isAndroid, isIOS } from 'react-device-detect';
import LeafletWrapper from '../LeafletWrapper';

/**
 * @name 전단 중계페이지
 * @description 마트GO앱이 있을때 앱 전단, 없을 시 웹 전단
 */
function SystemLauncher(): React.ReactElement {
  const _route = location.href.split('_route=')[1];
  const _url = `${process.env.REACT_APP_GO_URL}${_route}`;

  const navigate = useNavigate();

  const androidOpenApp = useCallback(
    url => {
      // S.brower_fallback_url 설정하여 앱 없을 시 웹 전단 이동
      const intentUrl =
        'intent://m.coupon.lottemart?url=' +
        url +
        '#Intent;scheme=lmscp;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.lottemart.lmscp;S.browser_fallback_url=' +
        encodeURIComponent(
          `${process.env.REACT_APP_BASE_FRONT_ORIGIN}${_route}`,
        ) +
        ';end';

      window.location.href = intentUrl;
    },
    [_route],
  );

  const runLeaflet = useCallback(() => {
    const url = encodeURIComponent(_url);
    if (isAndroid) {
      androidOpenApp(url);
    } else if (isIOS) {
      // 앱 있을 시 앱전단+웹전단 이동, 앱 없을 시 웹전단 이동
      window.location.href =
        getUA.indexOf('mcoupon') > -1
          ? url
          : 'lottemart-mcoupon-iphone://?url=' + url;
      navigate(_route);
    } else {
      navigate(_route || '/');
    }
  }, [androidOpenApp, _url, navigate, _route]);

  useEffect(() => {
    if (!isIOSWebView || !isAndWebView) {
      runLeaflet();
    }
  }, [runLeaflet]);

  return <LeafletWrapper />;
}

export default SystemLauncher;
